import * as API from '../_api';

export const create = async ({ dispatch }, commercial) => {
  try {
    await API.create(commercial);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message, { root: true });
    return false;
  }
};

export const read = async ({ commit, dispatch }) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message, { root: true });
    return false;
  }
};

export const update = async ({ dispatch }, commercial) => {
  try {
    await API.update(commercial);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message, { root: true });
    return false;
  }
};

export const del = async ({ dispatch }, commercial) => {
  try {
    await API.del(commercial);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message, { root: true });
    return false;
  }
};
